import { createFileRoute } from "@tanstack/react-router";

import { AiQualityPage } from "./-components/ai-quality-page";

export const Route = createFileRoute("/operator/ai-quality")({
  component: RouteComponent,
});

function RouteComponent() {
  const { access } = Route.useRouteContext();
  return <AiQualityPage permissions={access.permissions} />;
}
